<template>
    <div :class="[b(), className]" :style="styleSizeName">
      <div :ref="id" :style="styleChartName">
        <div
          style="width: 100%;height: 100%;"
          :style="{ borderRadius: borderRadius}"
        >
          <ImgMap
            :list="mapList"
            :src="img"
            :main-color="mainColor"
            :background-color="backgroundColor"
            :text-style="textStyle"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ImgMap from './components/imgMap.vue'
  import factoryBg from '@/assets/img/factory0824.png'
  export default {
    name: 'imgMap',
    components: {
      ImgMap
    },
    props: {
    },
    data() {
      return {
        mapList: [
          {
            x: 500,
            y: 440,
            name: '生料制备工序',
            list: [
              {
                name: '生料制备工序排放',
                code: 'SCTH030',
                val: ''
              }
            ]
          },
          {
            x: 900,
            y: 400,
            name: '烧成工序',
            list: [
              {
                name: '化石燃料排放',
                code: 'SCTH021',
                val: ''
              },
              {
                name: '原料碳酸盐分解产生的CO2排放量',
                code: 'SCTH025',
                val: ''
              },
              {
                name: '非燃料碳煅烧产生的CO2排放量',
                code: 'SCTH026',
                val: ''
              },
              {
                name: '烧成工序电力排放',
                code: 'SCTH033',
                val: ''
              }
            ]
          },
          {
            x: 1100,
            y: 400,
            name: '煤粉制备工序',
            list: [
              {
                name: '煤粉制备工序排放',
                code: 'SCTH031',
                val: ''
              }
            ]
          },
        ],
        img: factoryBg,
        mainColor: '#FFFFFF',
        backgroundColor: 'rgba(19, 101, 205, 0.5)',
        textStyle: {
          fontColor: '#FFFFFF',
          fontSize: 12
        }
      }
    },
  
    computed: {
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
      updateChart() {
        if (!this.isDataCenter){
          return
        }
        let {
          categories = [],
          series = []
        } = this.getDimentionOption()
        series = series.map(item => {
          return {
            ...item,
            data: item.data.map(dataItem => {
              const { code } = this.prop.metrics.find(metItem => metItem.fieldName === item.name)
              return dataItem[code] || dataItem
            })
          }
        })
        this.mapList = this.mapList.map((item, index) => {
          return {
            ...item,
            list: series[index].data
          }
        })
        // this.mapList = this.mapList.map((item, index) => {
        //   const newItemList = item.list.map(liItem => {
        //     const { value = 0 } = (chart_option.series[0].data.find(serItem => serItem.name === liItem.code) || {})
        //     return {
        //       ...liItem,
        //       val: `${value.toFixed(2)} tCO2`
        //     }
        //   })
        //   return {
        //     ...item,
        //     list: newItemList
        //   }
        // })
      }
    }
  }
  
  </script>
  
  <style lang="scss" scoped>

  </style>
  